import { render, staticRenderFns } from "./SdsReconfirmationTable.vue?vue&type=template&id=4d59c067"
import script from "./SdsReconfirmationTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsReconfirmationTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports